<template>
  <div class="chart-container">
    <Radar :data="data" :options="options" data-convert="position" />
  </div>
  <div class="customLegend">
    <div class="label" v-for="(dataset, index) in data.datasets" :key="index">
      <div class="inline">
        <div
          class="color"
          :style="{
            backgroundColor: dataset.pointBackgroundColor,
          }"
        />
        {{ dataset.label }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { Radar } from "vue-chartjs";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { useDark } from "@vueuse/core";

const isDark = useDark();

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  darkmode: {
    type: Boolean,
    default: true,
  },
});

const options = computed(() => {
  const ticksColor = isDark.value && props.darkmode ? "#FFFFFF" : "#1D1D1D";
  const gridColor = isDark.value && props.darkmode ? "#464646" : "#D2D1D1";

  return {
    responsive: true,
    maintainAspectRatio: false,
    borderWidth: 1.6,
    pointBorderWidth: 3.5,
    point: 5,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
        backgroundColor: ticksColor,
        caretPadding: 10,
        padding: {
          x: 8,
          y: 8,
        },
        yAlign: "center",
        displayColors: false,
        titleFont: {
          size: 14,
          family: "bio-sans",
          weight: "600",
        },
        titleColor: !isDark.value && props.darkmode ? "#FFFFFF" : "#1D1D1D",
        titleMarginBottom: 4,
        titleAlign: "center",
        bodyAlign: "center",
        bodyColor: !isDark.value && props.darkmode ? "#FFFFFF" : "#1D1D1D",
        bodyFont: {
          size: 12,
          family: "bio-sans",
        },
      },
    },
    scales: {
      r: {
        angleLines: {
          color: gridColor,
        },
        beginAtZero: true,
        min: 0,
        max: 100,
        grid: {
          lineWidth: 1.6,
          color: gridColor,
        },
        ticks: {
          count: 5,
          display: false,
        },
        pointLabels: {
          color: ticksColor,
          padding: 8,
          font: {
            family: "bio-sans",
            size: 16,
          },
        },
      },
    },
  };
});
</script>
